 <i class="fas fa-times icon close-button" (click)="close.emit()"></i>
 <div class="faq-scroll-container">
     <div [innerHTML]="faqHtml">
     </div>
 </div>
